/**
 * @generated SignedSource<<66df7d6ee6973cfda50e43ef95520224>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditDates_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditDatesAdd_package" | "PackageEditDatesList_package">;
  readonly " $fragmentType": "PackageEditDates_package";
};
export type PackageEditDates_package$key = {
  readonly " $data"?: PackageEditDates_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditDates_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditDates_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditDatesAdd_package"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PackageEditDatesList_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "e2dbc88298b08c084bdf32b86a210314";

export default node;
